import React, { useState, useEffect } from "react";
import {
  Body,
  Button,
  ButtonLayout,
  Modal,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  TextArea,
  Icon
} from "@common/AggregationComponent";
import { useDispatch, useSelector } from "react-redux";
import { CombinedReducersType } from "@type/index";
import { FeedbackActions } from "@redux/reducer";
import { getEcRenewalCompatibility } from "@util/common";

// import { postVisualSearchFeedback } from "@redux/services/index";
// import { useTranslation } from "react-i18next";

const FeedBackModal = (): any => {
  const dispatch = useDispatch();
  const feedbackStore = useSelector(
    (state: CombinedReducersType) => state.feedback
  );
  // const { t } = useTranslation();
  // const handlerClose = () => {
  //   dispatch(FeedbackActions.setFeedbackModal(false));
  // };

  const [questionnaireData, setQuestionnaireData] = useState<any>([]);
  const [selectedOptionOne, setSelectedOptionOne] = useState<any>(null);
  const [selectedOptionTwo, setSelectedOptionTwo] = useState<any>(null);
  const [selectedOptionThree, setSelectedOptionThree] = useState<any>([]);
  const [selectedOptionFour, setSelectedOptionFour] = useState<any>(null);
  const [selectedOptionFive, setSelectedOptionFive] = useState<any>([]);
  const [textareaValueSix, setTextareaValueSix] = useState<string>("");
  const [isBtnDisabled, setIsBtnDisabled] = useState<boolean | string>("true");
  const [isSendFeedbackSuccess, setIsSendFeedbackSuccess] =
    useState<boolean>(false);

  const mapReducerQuestionnaireDataToState = () => {
    setQuestionnaireData(feedbackStore.questionnaireData);
    setSelectedOptionOne(feedbackStore.questionnaireData[0].answer);
    setSelectedOptionTwo(feedbackStore.questionnaireData[1].answer);
    setSelectedOptionFour(feedbackStore.questionnaireData[3].answer);
    setTextareaValueSix(feedbackStore.questionnaireData[5].answer || "");
    const arrThree: any = [];
    feedbackStore.questionnaireData[2].options.map((item: any) => {
      if (item.isChecked) {
        arrThree.push(item.value);
      }
      return null;
    });
    const arrFive: any = [];
    feedbackStore.questionnaireData[4].options.map((item: any) => {
      if (item.isChecked) {
        arrFive.push(item.value);
      }
      return null;
    });
    setSelectedOptionThree(arrThree);
    setSelectedOptionFive(arrFive);
  };

  useEffect(() => {
    mapReducerQuestionnaireDataToState();
  }, [feedbackStore.questionnaireData, feedbackStore.isVisibleFeedbackModal]);

  useEffect(() => {
    if (
      selectedOptionOne &&
      selectedOptionTwo &&
      selectedOptionThree.length > 0 &&
      selectedOptionFour &&
      selectedOptionFive.length > 0
    ) {
      setIsBtnDisabled(false);
    } else {
      setIsBtnDisabled("true");
    }
  }, [
    questionnaireData,
    selectedOptionOne,
    selectedOptionTwo,
    selectedOptionThree,
    selectedOptionFour,
    selectedOptionFive
  ]);

  const handleRadioChange = (index: any, value: any) => {
    dispatch(FeedbackActions.setSelectRadioValue({ value, index }));
    switch (index) {
      case 0:
        setSelectedOptionOne(value);
        break;
      case 1:
        setSelectedOptionTwo(value);
        break;
      case 3:
        setSelectedOptionFour(value);
        break;
      default:
        return null;
    }
    return null;
  };

  const handleRadioChecked = (index: any, value: any) => {
    switch (index) {
      case 0:
        return value === selectedOptionOne;
      case 1:
        return value === selectedOptionTwo;
      case 3:
        return value === selectedOptionFour;
      default:
        return false;
    }
  };

  const handleCheckboxIsCheckedArr = (arr: any, index: any) => {
    const optionThreeArr = JSON.parse(JSON.stringify(questionnaireData));
    const optionsArr = JSON.parse(
      JSON.stringify(optionThreeArr[index].options)
    );
    optionsArr.map((option: any) => {
      if (arr.indexOf(option.value) !== -1) {
        option.isChecked = true;
      } else {
        option.isChecked = false;
      }
      return null;
    });
    const _optionsThreeObj = JSON.parse(
      JSON.stringify(questionnaireData[index])
    );
    optionThreeArr.splice(index, 1, {
      ..._optionsThreeObj,
      options: optionsArr
    });
    return optionThreeArr;
  };

  const onChangeCheckbox = (index: any, value: any) => {
    switch (index) {
      case 2:
        if (selectedOptionThree.indexOf(value) !== -1) {
          const arr = selectedOptionThree;
          arr.splice(selectedOptionThree.indexOf(value), 1);
          setSelectedOptionThree(arr);
          dispatch(
            FeedbackActions.setCheckboxIsChecked(
              handleCheckboxIsCheckedArr(arr, 2)
            )
          );
        } else {
          const arr = selectedOptionThree;
          arr.push(value);
          setSelectedOptionThree(arr);
          dispatch(
            FeedbackActions.setCheckboxIsChecked(
              handleCheckboxIsCheckedArr(arr, 2)
            )
          );
        }
        break;
      case 4:
        if (selectedOptionFive.indexOf(value) !== -1) {
          const arr = selectedOptionFive;
          arr.splice(selectedOptionFive.indexOf(value), 1);
          setSelectedOptionFive(arr);
          dispatch(
            FeedbackActions.setCheckboxIsChecked(
              handleCheckboxIsCheckedArr(arr, 4)
            )
          );
        } else {
          const arr = selectedOptionFive;
          arr.push(value);
          setSelectedOptionFive(arr);
          dispatch(
            FeedbackActions.setCheckboxIsChecked(
              handleCheckboxIsCheckedArr(arr, 4)
            )
          );
        }
        break;
      default:
        return null;
    }
    return null;
  };

  // const handleFeedbackSendRequestParams = () => ({
  //   Question1: {
  //     Question: questionnaireData[0].question,
  //     Answer: questionnaireData[0].answer,
  //     Options: {
  //       1: questionnaireData[0].options[0].value,
  //       2: questionnaireData[0].options[1].value,
  //       3: questionnaireData[0].options[2].value,
  //       4: questionnaireData[0].options[3].value,
  //       5: questionnaireData[0].options[4].value
  //     }
  //   },
  //   Question2: {
  //     Question: questionnaireData[1].question,
  //     Answer: questionnaireData[1].answer,
  //     Options: {
  //       1: questionnaireData[1].options[0].value,
  //       2: questionnaireData[1].options[1].value,
  //       3: questionnaireData[1].options[2].value,
  //       4: questionnaireData[1].options[3].value,
  //       5: questionnaireData[1].options[4].value,
  //       6: questionnaireData[1].options[5].value
  //     }
  //   },
  //   Question3: {
  //     Question: questionnaireData[2].question,
  //     Answer: selectedOptionThree.toString(),
  //     Options: {
  //       1: questionnaireData[2].options[0].value,
  //       2: questionnaireData[2].options[1].value,
  //       3: questionnaireData[2].options[2].value,
  //       4: questionnaireData[2].options[3].value,
  //       5: questionnaireData[2].options[4].value
  //     }
  //   },
  //   Question4: {
  //     Question: questionnaireData[3].question,
  //     Answer: questionnaireData[3].answer,
  //     Options: {
  //       1: questionnaireData[3].options[0].value,
  //       2: questionnaireData[3].options[1].value,
  //       3: questionnaireData[3].options[2].value,
  //       4: questionnaireData[3].options[3].value,
  //       5: questionnaireData[3].options[4].value
  //     }
  //   },
  //   Question5: {
  //     Question: questionnaireData[4].question,
  //     Answer: selectedOptionFive.toString(),
  //     Options: {
  //       1: questionnaireData[4].options[0].value,
  //       2: questionnaireData[4].options[1].value,
  //       3: questionnaireData[4].options[2].value,
  //       4: questionnaireData[4].options[3].value,
  //       5: questionnaireData[4].options[4].value
  //     }
  //   },
  //   Question6: {
  //     Question: questionnaireData[5].question,
  //     Answer: questionnaireData[5].answer,
  //     Options: {}
  //   }
  // });

  const handleClickSendBtn = () => {
    //TODO: 发送请求endpointB 的入参params handleFeedbackSendRequestParams()
    // const params: any = {
    //   user_feedback: handleFeedbackSendRequestParams()
    // };

    setIsSendFeedbackSuccess(true);
    // postVisualSearchFeedback(params)
    // handlerClose()
  };

  return (
    <Modal
      closeTitle={"Close Modal"}
      closeLabel={getEcRenewalCompatibility() ? " " : "Close"}
      errors={[]}
      id="sm-1"
      labelElement="h5"
      onBackdropClick={undefined}
      onRequestClose={() => {
        dispatch(FeedbackActions.setFeedbackModal(false));
      }}
      title={"Feedback"}
      titleId="modal-title"
      trapFocus
      variant="large"
      isOpen
      footer={
        <ButtonLayout reverseOnVertical={false} variant="fluid">
          {isSendFeedbackSuccess ? (
            <Button
              element="button"
              isSmall={false}
              variant="primary"
              width="fullWidth"
              onClick={() => {
                window.console.log("Back to ImageSearch");
              }}
              textTransform={"normal"}
            >
              Back to ImageSearch
            </Button>
          ) : (
            <Button
              disabled={isBtnDisabled}
              element="button"
              isSmall={false}
              variant="primary"
              width="fullWidth"
              onClick={handleClickSendBtn}
              textTransform={"normal"}
            >
              Send Feedback
            </Button>
          )}
        </ButtonLayout>
      }
    >
      {isSendFeedbackSuccess ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <Icon name="approval" size="64" title="" variant="default" />
          </div>
          <Body element="p" variant="standard" textAlign="center">
            Well-received your feedback!
          </Body>
          <Body element="p" variant="standard" textAlign="center">
            Thank you again for your collaboration.
          </Body>
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <Icon name="chat" size="64" title="" variant="default" />
          </div>
          <Body element="p" variant="standard" textAlign="center">
            Thank you for using ImageSearch!
          </Body>
          <Body element="p" variant="standard" textAlign="center">
            We are very glad if you can fill in the questionnaire
          </Body>
          <Body element="p" variant="standard" textAlign="center">
            below to help us improve our service
          </Body>
          <Body element="p" variant="standard">
            {questionnaireData.length !== 0 &&
              questionnaireData.map((questionnaire: any, indexOne: any) => {
                switch (questionnaire.type) {
                  case "radio":
                    return (
                      <>
                        <h2>
                          {questionnaire.number}.{questionnaire.question}
                        </h2>
                        <RadioGroup>
                          {questionnaire.options.map((option: any) => (
                            <Radio
                              checked={handleRadioChecked(
                                indexOne,
                                option.value
                              )}
                              id={`height-gender-${option.value}`}
                              key={option.label}
                              label={option.label}
                              name="gender-radio"
                              onChange={() => {
                                handleRadioChange(indexOne, option.value);
                              }}
                              value={option.value}
                            />
                          ))}
                        </RadioGroup>
                      </>
                    );
                  case "check box":
                    return (
                      <>
                        <h2>
                          {questionnaire.number}.{questionnaire.question}
                        </h2>
                        <CheckboxGroup
                          error=""
                          hint=""
                          id="Checkbox-color-17"
                          required={false}
                          columnCount={{ sm: 2, md: 2, lg: 1 }}
                        >
                          {questionnaire.options.map((option: any) => (
                            <Checkbox
                              checked={!!option.isChecked}
                              id={option.value}
                              key={option.value}
                              label={option.label}
                              name={option.label}
                              onChange={() => {
                                onChangeCheckbox(indexOne, option.value);
                              }}
                              value={option.value}
                            />
                          ))}
                        </CheckboxGroup>
                      </>
                    );
                  case "textarea":
                    return (
                      <>
                        <h2>
                          {questionnaire.number}.{questionnaire.question}
                        </h2>
                        <TextArea
                          aria-label="Max characters: 100"
                          charCountAriaLabel="Characters remaining"
                          description=""
                          disabled={false}
                          error=""
                          id="text-area-1"
                          maxCharacters={100}
                          onChange={(e: any) => {
                            setTextareaValueSix(e.target.value);
                            dispatch(
                              FeedbackActions.setTextAreaValue(e.target.value)
                            );
                          }}
                          placeholder=""
                          value={textareaValueSix}
                        />
                      </>
                    );
                  default:
                    return null;
                }
              })}
          </Body>
        </>
      )}
    </Modal>
  );
};

export default FeedBackModal;
